// extracted by mini-css-extract-plugin
export var configurationSection = "_zb-0";